import { render, staticRenderFns } from "./backoffice-cirurgias-conjuntas-associadas.vue?vue&type=template&id=6a2ac8c0&scoped=true"
import script from "./backoffice-cirurgias-conjuntas-associadas.vue?vue&type=script&lang=ts"
export * from "./backoffice-cirurgias-conjuntas-associadas.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-cirurgias-conjuntas-associadas.vue?vue&type=style&index=0&id=6a2ac8c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2ac8c0",
  null
  
)

export default component.exports